<template>
  <div id="logsViewer">
    <div class="form-group mb-4">
      <b-container class="pb-0 pt-0">
        <b-row class="mt-4">
          <label class="pl-0 col-3 defaultLabel"> Such-Text </label>
          <div class="col-9 pl-0">
            <input
              id="freeTextSearchInput"
              v-model="filterObject.SearchString"
              type="text"
              class="form-control"
              placeholder="nach Text filtern"
            >
          </div>
        </b-row><b-row class="mt-4">
          <label class="pl-0 col-3 defaultLabel"> Von-Datum </label>
          <div class="col-9 pl-0">
            <u-date-picker
              v-model="filterObject.From"
              label="von"
            />
          </div>
        </b-row>
        <b-row class="mt-4">
          <label class="pl-0 col-3 defaultLabel"> Bis-Datum </label>
          <div class="col-9 pl-0">
            <u-date-picker
              v-model="filterObject.To"
              label="bis"
            />
          </div>
        </b-row>
      </b-container>
    </div>
    <u-error-handling
      v-if="errorObject"
      :error-object="errorObject"
    />
    <u-loader v-if="isLoading" />
    <template v-else>
      <b-pagination
        v-model="filterObject.PageNumber"
        :total-rows="totalResults"
        :per-page="filterObject.PageSize"
        prev-text="Vorherige"
        next-text="Nächste"
        first-text="<<"
        last-text=">>"
        class="mt-4"
      />
      <table class="w-100 logEntries ml-2 mt-4">
        <thead>
          <tr>
            <th>Zeit</th>
            <th>Beschreibung</th>
            <th>Benutzer</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(logEntry, index) in logEntries.entires"
            :key="index"
          >
            <td>
              {{ logEntry.eventDateTime | moment("DD.MM.YYYY hh:mm:ss") }}
            </td>
            <td>
              {{ logEntry.description }}
            </td>
            <td>
              {{ logEntry.account }}
            </td>
          </tr>
        </tbody>
      </table>
    </template>
  </div>
</template>

<script>
import { GetAuditLogs } from "@/services/logs.service.js";
import UDatePicker from "@/components/common/UDatePicker.vue";
export default {
  components: {
    UDatePicker,
  },
  props: {
    scope: {
      type: String,
      default: "admin",
    },
  },
  data() {
    return {
      isLoading: false,
      errorObject: null,
      filterObject: {
        SearchString: "",
        EventType: 1,
        SortBy: "",
        SortOrder: 0,
        PageSize: 25,
        PageNumber: 1,
        From: null,
        To: null,
      },
      logEntries: [],
      searchQueryQueue: [],
      logLevels: null,
      totalResults: 0,
      logTypes: {
        1: "Fehlgeschlagenes Login",
        2: "Admin Login",
        3: "Vertrag aktualisiert",
        4: "Vertrag deaktiviert",
        5: "Vertragsversion gelöscht",
        6: "Neue Version erstellt",
        7: "Neue Edition erstellt",
        8: "Änderung vorgenommen",
        9: "Vertragsedition gelöscht",
        10: "Neue Publikation erstellt",
        11: "Publikation aktualisiert",
        12: "Publikation gelöscht",
      },
    };
  },
  watch: {
    scope() {
      this.GetLogEntries();
    },
    "filterObject.SearchString"() {
      this.filterObject.PageNumber = 1;
      this.GetLogEntries();
    },
    "filterObject.EventType"() {
      this.filterObject.PageNumber = 1;
      this.GetLogEntries();
    },
    "filterObject.From"() {
      this.filterObject.PageNumber = 1;
      this.GetLogEntries();
    },
    "filterObject.To"() {
      this.filterObject.PageNumber = 1;
      this.GetLogEntries();
    },
    "filterObject.PageNumber"() {
      this.GetLogEntries();
    },
  },
  created() {
    this.GetLogEntries(true);
  },
  methods: {
    GetLogEntries(immediateReload) {
      if (immediateReload) {
        this.getAllLogEntries();
        return;
      }

      this.isLoading = true;
      this.errorObject = null;
      this.logEntries = [];

      this.searchQueryQueue.push(new Date().getTime());
      setTimeout(() => {
        if (this.searchQueryQueue.length > 1) {
          this.searchQueryQueue = this.searchQueryQueue.slice(1);
          return;
        }

        this.getAllLogEntries();
      }, 400);
    },
    getAllLogEntries() {
      this.searchQueryQueue = [];
      this.isLoading = true;

      GetAuditLogs(
        this.scope,
        this.filterObject,
        (results) => {
          this.isLoading = false;
          this.logEntries = results;
          this.totalResults = results.numberOfItems;
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
  },
};
</script>

<style scoped>
.logEntries {
  font-size: small;
  table-layout: fixed;
}

.logEntries thead th:nth-child(1) {
  width: 15%;
}
.logEntries thead th:nth-child(2) {
  width: 60%;
}
.logEntries thead th:nth-child(3) {
  width: 25%;
}
.logEntries tbody tr {
  border-bottom: 1px solid gainsboro;
}
.logEntries td,
.logEntries th {
  padding: 8px 4px;
}

/deep/ .page-item.active .page-link {
  z-index: 1;
  color: #fff;
  background-color: #ff5959;
  border-color: red;
}
/deep/.page-link:hover {
  z-index: 2;
  color: red;
  text-decoration: none;
  background-color: #fdd;
  border-color: #fdd;
}

/deep/ a:hover {
  color: #0056b3;
  text-decoration: underline;
}

/deep/ .page-link {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: red;
  background-color: rgb(255, 255, 255);
  border: 1px solid #dee2e6;
}
</style>
